// import React, { useEffect, useState } from 'react';
// import client from '../../sanity/client';
// import '../Chemin/CheminPage.scss';
// import { ArrowLeft, ArrowRight } from '../../assets/svg';
// import { useLanguage } from '../../components/LanguageContext';
// import veilleuse from './veilleuse';
// import '../Poete/SubPagePoete.scss';

// const PoetePage = () => {
//   const [data, setData] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0); // pour le carrousel
//   const { language } = useLanguage();
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);

//   // Gestion du redimensionnement
//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobileView(window.innerWidth <= 768);
//     };
//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, []);

//   useEffect(() => {
//     const fetchData = async () => {
//       const query = `*[_type == "poete"][0]{
//         title,
//         carrousel[]{ "imageUrl": asset->url + "?auto=format" },
//         colonneGauche,
//         colonneDroite,
//         parutions[]{
//           sectionTitle,
//           paragraphs,
//           "imageUrl": image.asset->url + "?auto=format"
//         }
//       }`;
//       const result = await client.fetch(query);
//       console.log("Données récupérées :", result);
//       setData(result);
//     };

//     fetchData();
//   }, []);

//   // Fonctions du carrousel
//   const goToNextSlide = () => {
//     setCurrentIndex((prevIndex) => (prevIndex + 1) % data.carrousel.length);
//   };

//   const goToPrevSlide = () => {
//     setCurrentIndex((prevIndex) => (prevIndex - 1 + data.carrousel.length) % data.carrousel.length);
//   };

//   if (!data) return <div>Loading...</div>;

//   return (
//     <>
//       {/* Section du carrousel */}
//       <div className="chemin-page titre-page">
//         <h1 className="chemin-text">{data.title[language]}</h1>
//         {data.carrousel?.length > 0 && (
//           <div className="carousel">
//             <div className="carousel-image-container">
//               {data.carrousel.map((image, index) => (
//                 <img
//                   key={index}
//                   src={image.imageUrl}
//                   alt={`Slide ${index + 1}`}
//                   className={`carousel-image ${index === currentIndex ? 'active' : ''}`}
//                 />
//               ))}
//             </div>
//             <div className="carousel-controls">
//               <button className="carousel-control prev" onClick={goToPrevSlide}>
//                 <ArrowLeft />
//               </button>
//               <button className="carousel-control next" onClick={goToNextSlide}>
//                 <ArrowRight />
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* Section des colonnes de texte */}
//       <section className="text_section">
//         <div className="text_parts">
//           <div className="text_content_left">
//             {data.colonneGauche?.[language]?.map((paragraph, idx) => (
//               <p key={idx}>
//                 {paragraph.split('\n').map((line, i) => (
//                   <span key={i}>
//                     {line}
//                     <br />
//                   </span>
//                 ))}
//               </p>
//             ))}
//           </div>
//           <div className="text_content_right">
//             {data.colonneDroite?.[language]?.map((paragraph, idx) => (
//               <p key={idx}>
//                 {paragraph.split('\n').map((line, i) => (
//                   <span key={i}>
//                     {line}
//                     <br />
//                   </span>
//                 ))}
//               </p>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Section Parutions – affichage des sous-pages */}
//       {data.parutions?.map((item, index) => (
//         <div key={index} id="parutions" className="sub-page-left chemin-page">
//           {isMobileView ? (
//             // En mode mobile : Ordre : Titre, Image, Texte
//             <>
//               <div className="spl_left_content">
//                 <h2 className="right_title chemin-text">
//                   {item.sectionTitle?.[language] || item.sectionTitle?.fr}
//                 </h2>
//               </div>
//               <div className="spl_right_content right_content_parution">
//                 {item.imageUrl && (
//                   <img className="right_img" src={item.imageUrl} alt={item.sectionTitle?.[language]} />
//                 )}
//               </div>
//               <div className="spl_left_content">
//                 {item.paragraphs?.[language]?.map((paragraph, idx) => (
//                   <p className="left_text" key={idx}>
//                     {paragraph.split('\n').map((line, i) => (
//                       <span key={i}>
//                         {line}
//                         <br />
//                       </span>
//                     ))}
//                   </p>
//                 ))}
//               </div>
//             </>
//           ) : (
//             // En mode desktop : Ordre inchangé : Image à gauche, Titre et texte à droite
//             <>
//               <div className="spl_right_content right_content_parution">
//                 {item.imageUrl && (
//                   <img className="right_img" src={item.imageUrl} alt={item.sectionTitle?.[language]} />
//                 )}
//               </div>
//               <div className="spl_left_content">
//                 <h2 className="right_title chemin-text">
//                   {item.sectionTitle?.[language] || item.sectionTitle?.fr}
//                 </h2>
//                 {item.paragraphs?.[language]?.map((paragraph, idx) => (
//                   <p className="left_text" key={idx}>
//                     {paragraph.split('\n').map((line, i) => (
//                       <span key={i}>
//                         {line}
//                         <br />
//                       </span>
//                     ))}
//                   </p>
//                 ))}
//               </div>
//             </>
//           )}
//         </div>
//       ))}

//       {/* Vous pouvez ajouter ici d'autres composants ou sections, par exemple veilleuse */}
//       <veilleuse />
//     </>
//   );
// };

// export default PoetePage;

import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import client from '../../sanity/client';
import '../Chemin/CheminPage.scss';
import { ArrowLeft, ArrowRight } from '../../assets/svg';
import { useLanguage } from '../../components/LanguageContext';
import useScrollPosition from '../../hooks/useScrollPosition';
import Veilleuse from './Veilleuse';
import Parutions from './Parutions';
import '../Poete/SubPagePoete.scss';

const PoetePage = () => {
  const [data, setData] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const { language } = useLanguage();
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const intervalRef = useRef(null);
  const location = useLocation();
  
  // Hook pour gérer la position de scroll
  useScrollPosition();

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const query = `*[_type == "poete"][0]{
        title,
        carrousel[]{ "imageUrl": asset->url + "?auto=format" },
        colonneGauche,
        colonneDroite,
        parutions[]{
          sectionTitle,
          paragraphs,
          "imageUrl": image.asset->url + "?auto=format"
        }
      }`;
      const result = await client.fetch(query);
      setData(result);
      startAutoSlide(result);
    };

    fetchData();

    return () => clearInterval(intervalRef.current);
  }, []);
  
  useEffect(() => {
    if (location.hash) {
      const anchor = location.hash.replace('#', '');
  
      const scrollToAnchor = () => {
        const el = document.getElementById(anchor);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        } else {
          // Si pas encore présent, retente après un délai
          setTimeout(scrollToAnchor, 100);
        }
      };
  
      scrollToAnchor();
    }
  }, [location]);

  const startAutoSlide = (data) => {
    clearInterval(intervalRef.current);
    if (data?.carrousel?.length > 1) {
      intervalRef.current = setInterval(() => {
        setCurrentIndex(prev => (prev + 1) % data.carrousel.length);
      }, 3000);
    }
  };

  const resetAutoSlide = () => {
    if (data) startAutoSlide(data);
  };

  const goToNextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % data.carrousel.length);
    resetAutoSlide();
  };

  const goToPrevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + data.carrousel.length) % data.carrousel.length);
    resetAutoSlide();
  };

  if (!data) return <div>Loading...</div>;

  return (
    <>
      <div className="chemin-page titre-page">
        <h1 className="chemin-text" data-aos="fade-in" data-aos-duration="800">
          {data.title[language]}
        </h1>
        {data.carrousel?.length > 0 && (
          <div className="carousel" data-aos="fade-in" data-aos-duration="1000" data-aos-delay="200">
            <div className="carousel-image-container">
              {data.carrousel.map((image, index) => (
                <img
                  key={index}
                  src={image.imageUrl}
                  alt={`Slide ${index + 1}`}
                  className={`carousel-image ${index === currentIndex ? 'active' : ''}`}
                />
              ))}
            </div>
            <div className="carousel-controls">
              <button className="carousel-control prev" onClick={goToPrevSlide}>
                <ArrowLeft />
              </button>
              <button className="carousel-control next" onClick={goToNextSlide}>
                <ArrowRight />
              </button>
            </div>
          </div>
        )}
      </div>

      <section className="text_section">
        <div className="text_parts">
          <div className="text_content_left" data-aos="fade-right" data-aos-duration="800" data-aos-delay="100">
            {data.colonneGauche?.[language]?.map((paragraph, idx) => (
              <p key={idx} data-aos="fade-in" data-aos-duration="600" data-aos-delay={200 + (idx * 100)}>
                {paragraph.split('\n').map((line, i) => (
                  <span key={i}>{line}<br /></span>
                ))}
              </p>
            ))}
          </div>
          <div className="text_content_right" data-aos="fade-left" data-aos-duration="800" data-aos-delay="100">
            {data.colonneDroite?.[language]?.map((paragraph, idx) => (
              <p key={idx} data-aos="fade-in" data-aos-duration="600" data-aos-delay={200 + (idx * 100)}>
                {paragraph.split('\n').map((line, i) => (
                  <span key={i}>{line}<br /></span>
                ))}
              </p>
            ))}
          </div>
        </div>
      </section>

      {data.parutions?.map((item, index) => (
        <div key={index} id="parutions" className="sub-page-left chemin-page" data-aos="fade-in" data-aos-duration="800" data-aos-delay={index * 200}>
          {isMobileView ? (
            <>
              <div className="spl_left_content">
                <h2 className="right_title chemin-text">
                  {item.sectionTitle?.[language] || item.sectionTitle?.fr}
                </h2>
              </div>
              <div className="spl_right_content right_content_parution">
                {item.imageUrl && (
                  <img className="right_img" src={item.imageUrl} alt={item.sectionTitle?.[language]} />
                )}
              </div>
              <div className="spl_left_content">
                {item.paragraphs?.[language]?.map((paragraph, idx) => (
                  <p className="left_text" key={idx}>
                    {paragraph.split('\n').map((line, i) => (
                      <span key={i}>{line}<br /></span>
                    ))}
                  </p>
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="spl_right_content right_content_parution">
                {item.imageUrl && (
                  <img className="right_img" src={item.imageUrl} alt={item.sectionTitle?.[language]} />
                )}
              </div>
              <div className="spl_left_content">
                <h2 className="right_title chemin-text">
                  {item.sectionTitle?.[language] || item.sectionTitle?.fr}
                </h2>
                {item.paragraphs?.[language]?.map((paragraph, idx) => (
                  <p className="left_text" key={idx}>
                    {paragraph.split('\n').map((line, i) => (
                      <span key={i}>{line}<br /></span>
                    ))}
                  </p>
                ))}
              </div>
            </>
          )}
        </div>
      ))}
      
      <div data-aos="fade-in" data-aos-duration="800">
        <Parutions />
      </div>
      
      <div data-aos="fade-in" data-aos-duration="800" data-aos-delay="200">
        <Veilleuse />
      </div>
    </>
  );
};

export default PoetePage;